<template>
  <!-- Mobile: schwebende Glass-Tab-Bar -->
  <nav class="navbar navbar--mobil">
    <router-link
      v-for="Tab in Tabs"
      :key="Tab.Pfad"
      :to="Tab.Pfad"
      class="nav-tab"
      :class="{ 'nav-tab--aktiv': IstAktiv(Tab.Pfad) }"
    >
      <span class="nav-tab-pip">
        <font-awesome-icon :icon="Tab.Icon" />
      </span>
      <span class="nav-tab-label">{{ Tab.Kurz }}</span>
    </router-link>
  </nav>

  <!-- Tablet/Desktop: Glass-Sidebar -->
  <nav class="navbar navbar--sidebar">
    <div class="sidebar-logo">
      <span class="logo-name">TopfKucker</span>
      <span class="logo-sub">Deine Küchenplanung</span>
    </div>

    <router-link
      v-for="Tab in Tabs"
      :key="Tab.Pfad"
      :to="Tab.Pfad"
      class="sidebar-item"
      :class="{ 'sidebar-item--aktiv': IstAktiv(Tab.Pfad) }"
    >
      <font-awesome-icon :icon="Tab.Icon" class="sidebar-icon" />
      <span>{{ Tab.Name }}</span>
    </router-link>

    <div class="sidebar-fuss">
      <button type="button" class="thema-schalter" @click="ThemaUmschalten">
        <font-awesome-icon :icon="theme.mode === 'dark' ? 'fa-solid fa-moon' : 'fa-solid fa-sun'" class="thema-icon" />
        <span class="thema-label">{{ theme.mode === 'dark' ? 'Dark Mode' : 'Light Mode' }}</span>
        <span class="schalter" :class="{ 'schalter--an': theme.mode === 'dark' }">
          <span class="schalter-knopf"></span>
        </span>
      </button>
    </div>
  </nav>
</template>

<script>
import { theme, setMode, ThemeProfilDaten } from '../composables/useTheme'
import { Benutzer, ProfilSpeichern } from '../composables/useBenutzer'

export default {
  name: 'NavBar',
  data() {
    return { theme }
  },
  computed: {
    Tabs() {
      return [
        { Pfad: '/',              Icon: 'fa-solid fa-house',         Name: 'Home',          Kurz: 'Home'    },
        { Pfad: '/wochenplanung', Icon: 'fa-solid fa-calendar-week', Name: 'Wochenplanung', Kurz: 'Planung' },
        { Pfad: '/rezepte',       Icon: 'fa-solid fa-book',          Name: 'Rezepte',       Kurz: 'Rezepte' },
        { Pfad: '/einkaufsliste', Icon: 'fa-solid fa-cart-shopping', Name: 'Einkaufsliste', Kurz: 'Einkauf' },
        { Pfad: '/einstellungen', Icon: 'fa-solid fa-gear',          Name: 'Einstellungen', Kurz: 'Einst.'  },
      ]
    }
  },
  methods: {
    IstAktiv(Pfad) {
      if (Pfad === '/') return this.$route.path === '/'
      return this.$route.path.startsWith(Pfad)
    },
    ThemaUmschalten() {
      setMode(theme.mode === 'dark' ? 'light' : 'dark')
      if (Benutzer.Angemeldet) {
        ProfilSpeichern(ThemeProfilDaten()).catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
/* ── Mobile: schwebende Tab-Bar ──────────────────────── */
.navbar--mobil {
  display: flex;
  position: fixed;
  bottom: 12px;
  left: 12px;
  right: 12px;
  height: var(--nav-height);
  background: var(--glas-stark);
  -webkit-backdrop-filter: var(--glas-blur);
  backdrop-filter: var(--glas-blur);
  border: 1px solid var(--glas-rand);
  border-radius: var(--radius-xl);
  box-shadow: var(--glas-schatten);
  z-index: 100;
  align-items: stretch;
  padding: 0 4px;
}

.navbar--sidebar {
  display: none;
}

.nav-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  text-decoration: none;
  color: var(--color-text-muted);
  padding: 6px 2px 8px;
}

.nav-tab-pip {
  width: 44px;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  font-size: 0.95rem;
  transition: background-color 0.25s ease, transform 0.2s ease;
}

.nav-tab:active .nav-tab-pip {
  transform: scale(0.9);
}

.nav-tab-label {
  font-size: 0.6rem;
  font-weight: 600;
}

.nav-tab--aktiv {
  color: var(--color-primary);
}

.nav-tab--aktiv .nav-tab-pip {
  background: var(--akzent-weich);
}

/* ── Tablet/Desktop: Sidebar ─────────────────────────── */
@media (min-width: 768px) {
  .navbar--mobil {
    display: none;
  }

  .navbar--sidebar {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: var(--sidebar-width);
    background: var(--glas);
    -webkit-backdrop-filter: var(--glas-blur);
    backdrop-filter: var(--glas-blur);
    border-right: 1px solid var(--glas-rand);
    z-index: 100;
    gap: 2px;
    padding-bottom: 16px;
  }

  .sidebar-logo {
    padding: 26px 18px 22px;
    margin-bottom: 10px;
    border-bottom: 1px solid var(--color-border);
    flex-shrink: 0;
  }

  .logo-name {
    display: block;
    font-size: 1.3rem;
    font-weight: 800;
    letter-spacing: -0.02em;
    background: linear-gradient(120deg, var(--color-primary), var(--color-accent));
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  .logo-sub {
    display: block;
    font-size: 0.72rem;
    color: var(--color-text-muted);
    margin-top: 3px;
  }

  .sidebar-item {
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 11px 14px;
    margin: 0 10px;
    border-radius: var(--radius-md);
    text-decoration: none;
    color: var(--color-text);
    font-size: 0.9rem;
    font-weight: 550;
    transition: background-color 0.2s ease, color 0.2s ease, transform 0.15s ease;
  }

  .sidebar-item:hover {
    background: var(--color-bg-alt);
    transform: translateX(2px);
  }

  .sidebar-item--aktiv {
    background: var(--akzent-weich);
    color: var(--color-primary);
  }

  .sidebar-icon {
    width: 18px;
    text-align: center;
    flex-shrink: 0;
    font-size: 0.95rem;
  }

  /* Theme-Umschalter unten */
  .sidebar-fuss {
    margin-top: auto;
    padding: 12px 10px 0;
    border-top: 1px solid var(--color-border);
  }

  .thema-schalter {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 11px 14px;
    border: none;
    border-radius: var(--radius-md);
    background: transparent;
    color: var(--color-text);
    font-family: inherit;
    font-size: 0.85rem;
    font-weight: 550;
    cursor: pointer;
  }

  .thema-schalter:hover {
    background: var(--color-bg-alt);
  }

  .thema-icon {
    width: 18px;
    text-align: center;
    color: var(--color-accent);
    font-size: 0.95rem;
  }

  .thema-label {
    flex: 1;
    text-align: left;
  }

  .schalter {
    width: 38px;
    height: 22px;
    border-radius: 999px;
    background: var(--color-border);
    position: relative;
    flex-shrink: 0;
    transition: background-color 0.25s ease;
  }

  .schalter--an {
    background: var(--color-primary);
  }

  .schalter-knopf {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  .schalter--an .schalter-knopf {
    transform: translateX(16px);
  }
}
</style>
